import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AuthContext, AuthDispatchContext } from "../../contexts/authContext";
import { FieldValues, useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import * as joi from "joi";
import { useNavigate } from "react-router-dom";
import Turnstile from "react-turnstile";

const schema = joi
  .object({
    username: joi.string().required(),
    password: joi.string().required(),
    passwordConfirmation: joi.ref("password"),
  })
  .with("password", "passwordConfirmation");

export default function SignUp() {
  const authContext = useContext(AuthContext);
  const authDispatchContext = useContext(AuthDispatchContext);
  const navigate = useNavigate();
  const [turnstileToken, setTurnstileToken] = useState('');
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(schema),
  });

  async function onSubmit(fieldData: FieldValues) {
    try {
      const baseUrl = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${baseUrl}/auth/signup`, {
        username: fieldData.username,
        password: fieldData.password,
        turnstileToken
      });
      if (response.status === 200) {
        const data = response.data;
        if (authDispatchContext) {
          authDispatchContext({
            type: "SET",
            authInfo: {
              username: fieldData.username,
              bearerToken: data.token
            },
          });
          setShouldRedirect(true);
        }
      }
    } catch (e: any) {
      if (e.response?.data?.code === "USERNAME_ALREADY_EXISTS") {
        setError("username", {
          type: "manual",
          message: "This username is already taken. Please choose another.",
        });
      }
      console.log(e);
    }
  }
  
  useEffect(() => {
    if (shouldRedirect && authContext?.authApiClient) {
      navigate("/vote");
    }
  }, [authContext, shouldRedirect, navigate]);

  return (
    <div className="flex flex-col max-w-lg mx-auto mt-16">
      <h2 className="text-center mb-11 font-bold">CREATE AN ACCOUNT</h2>
      <form className="flex flex-col gap-11" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col gap-1">
          <label htmlFor="username">Username</label>
          <input
            type="text"
            {...register("username", { required: true })}
            placeholder="Username"
          />
          {errors.username && (
            <div className="text-sm text-rose-500">
              {errors.username.message?.toString()}
            </div>
          )}
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            {...register("password", { required: true })}
            placeholder="Password"
          />
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="passwordConfirmation">Confirm Password</label>
          <input
            type="password"
            className={
              errors.passwordConfirmation ? "border-2 border-rose-500" : ""
            }
            {...register("passwordConfirmation", { required: true })}
            placeholder="Confirm Password"
          />
          {errors.passwordConfirmation && (
            <div className="text-sm text-rose-500">
              This field does not match the value of the "Password" field
            </div>
          )}
        </div>
        <Turnstile
          sitekey="0x4AAAAAACH7cmytUTEveGuQ"
          onVerify={(token) => setTurnstileToken(token)}
        />
        <button
          type="submit"
          className="btn-primary w-fit px-8 py-3 self-center"
        >
          SIGN UP
        </button>
      </form>
      <div className="text-sm text-center">
        <div>Already have an account ?</div>
        <a className="underline" href="/auth/login">
          Log In
        </a>
      </div>
    </div>
  );
}
